module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Heavy.woff2?dae12f4476c929a2b9a988d7e365dc8f";